import api from '@/core/api/client';

export interface ResendSettingsData {
  id: number;
  /** Sempre vem mascarado como '••••••••••' quando preenchido, ou null quando não configurado. */
  apiKey: string | null;
  fromAddress: string | null;
  replyTo: string | null;
  updatedAt: string;
}

export const resendSettingsService = {
  async get(): Promise<ResendSettingsData> {
    const res = await api.get('/configuracoes/resend');
    return res.data;
  },

  async update(data: Partial<ResendSettingsData>): Promise<ResendSettingsData> {
    const res = await api.patch('/configuracoes/resend', data);
    return res.data;
  },
};
